<script>
import NewProfessional from "./NewProfessional";
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import dateMixin from "@/mixins/dateMixin";
import accountMixin from "@/mixins/accountMixin";

import { mapState, mapActions } from "vuex";

export default {
  title: "Profissionais",

  mixins: [dateMixin, accountMixin],

  data() {
    return {
      newProfessional: false,
      search: "",
      newProfessionalComponentKey: 0,
      errorSnackbar: false,
      errorMessage: ""
    };
  },

  components: {
    NewProfessional,
    Pagination,
    PreloaderTable
  },

  computed: {
    ...mapState("professionals", [
      "list",
      "preloader",
      "pagination",
      "sort",
      "type",
      "text_search"
    ])
  },

  methods: {
    ...mapActions("professionals", [
      "listAll",
      "setCurrentPage",
      "setSort",
      "setType",
      "setTextSearch"
    ]),
    forceRerenderNewProfessionalComponent() {
      this.newProfessionalComponentKey += 1;
    },
    closeNewProfessionalComponent() {
      this.newProfessional = false;
    },
    activeSnackbarError(val) {
      this.errorMessage = val;
      this.errorSnackbar = true;
    },
    input(value) {
      this.setCurrentPage(value);
    }
  },

  mounted() {
    if (!this.list || !this.list.length) this.listAll();
  },

  watch: {
    text_search(text_search) {
      this.search = text_search;
    }
  }
};
</script>

<template>
  <div class="box">
    <div class="title">PROFISSIONAIS</div>

    <div class="buttons-filters">
      <div class="new-group mb-0" @click="newProfessional = !newProfessional">
        <img src="../../../static/plus.svg" /> Cadastrar novo profissional
      </div>

      <v-layout align-center justify-end row fill-height wrap>
        <input
          type="text"
          v-model="search"
          @keyup.enter="setTextSearch(search)"
          placeholder="buscar"
          class="with-icon icon-search sm text-lowercase"
        />
        <v-btn
          small
          class="primary text-lowercase"
          @click="setTextSearch(search)"
        >
          <span>buscar</span>
        </v-btn>
      </v-layout>
    </div>

    <transition name="fade" mode="out-in">
      <PreloaderTable v-if="preloader" />
      <div key="1" v-else class="table">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cidade</th>
              <th>E-mail</th>
              <th>Nº de Limpezas</th>
              <th>Adicionado</th>
              <th>Status</th>
              <th class="text-xs-right">Ação</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="professional in list" :key="professional.id">
              <td>
                <div :class="`with-image ${professional.status}`">
                  <img :src="professional.profile.profile_picture" />
                  {{ professional.first_name }} {{ professional.last_name }}
                </div>
              </td>
              <td>{{ professional.profile.city_name }}</td>
              <td>{{ professional.email }}</td>
              <td>{{ professional.accountable.completed_orders_count }}</td>
              <td>{{ professional.created_at | formatDate("DD/MM/Y") }}</td>
              <td>{{ professional.status | getAccountStatus }}</td>
              <td class="buttons" nowrap>
                <router-link
                  :to="'profissionais/' + professional.accountable.id"
                  class="btn btn-small bg-purple-outline float-right"
                  >editar</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>

        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="pagination.current"
            :total-visible="7"
            :length="pagination.totalPages"
            @input="input"
            circle
          ></v-pagination>
        </div>
      </div>
    </transition>

    <NewProfessional
      :key="newProfessionalComponentKey"
      @refresh="listAll() && forceRerenderNewProfessionalComponent()"
      v-show="newProfessional"
      v-on:errorMessage="activeSnackbarError"
      @close="closeNewProfessionalComponent()"
    />

    <v-snackbar v-model="errorSnackbar" color="error">
      <span>{{ this.errorMessage }}</span>
      <v-btn text @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Index.vue